import React, { useEffect, useRef } from 'react';
import { ChatMessageWrapper, MessageText, UserAvatar, LoadingDots } from './styles';
import { ClipLoader } from 'react-spinners';

const ChatMessage = ({ type, text, audioUrl, user, avatar, withSpinner, loading }) => {
  const audioRef = useRef(null);

  useEffect(() => {
    if (audioRef.current && type === 'coach') {
      audioRef.current.play();
    }
  }, [audioUrl]);

  return (
    <ChatMessageWrapper type={type}>
      <UserAvatar>
        <img src={avatar} alt={user.name} />
      </UserAvatar>
      <MessageText type={type}>
        {loading ? <LoadingDots>...</LoadingDots> : text}
        {withSpinner && <ClipLoader color="#00BFFF" loading={withSpinner} size={20} />}
        {audioUrl && (
          <audio className='audio' controls ref={audioRef} style={{ marginTop: '10px' }}>
            <source src={audioUrl} type="video/webm" />
            Your browser does not support the audio element.
          </audio>
        )}
      </MessageText>
    </ChatMessageWrapper>
  );
};

export default ChatMessage;
